import { render, staticRenderFns } from "./ReportStatsCard.vue?vue&type=template&id=7c65a9e0&scoped=true&"
import script from "./ReportStatsCard.vue?vue&type=script&lang=js&"
export * from "./ReportStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportStatsCard.vue?vue&type=style&index=0&id=7c65a9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c65a9e0",
  null
  
)

export default component.exports